import { Box, Link, Typography } from '@ace-clublabs/shared-component-library';

interface IDisclaimerComponent {
  clubCode: string;
  zipCode?: string | null;
  isERSSelected?: boolean;
  ersFee?: number;
}

const getServiceFeeUrl = ( zipCode?: string | null): string => {
  if (!zipCode) {
    return 'https://AAA.com/servicefee';
  }
  return `https://www.ace.aaa.com/membership/my-membership/membership-faq.html?area=vanity_servicefee&zip=${zipCode}&devicecd=PC#faqServiceFees`;
};

export const DisclaimerComponent = ({
  clubCode,
  zipCode,
  isERSSelected,
  ersFee,
}: IDisclaimerComponent): JSX.Element => {
  const serviceFeeUrl = getServiceFeeUrl(zipCode);

  const nonCaliforniaDisclaimer = (
    <Box className="non-ca-disclaimer">
      <Typography variant="b3Regular" sx={{ color: '#404040' }}>
        A non-refundable service fee applies each time you use Roadside Assistance for the first three days of your new
        membership. See{' '}
        <Link href={serviceFeeUrl} target="_blank" sx={{ fontSize: '0.875rem !important' }}>
          AAA.com/servicefee
        </Link>{' '}
        for fee amount.
      </Typography>
    </Box>
  );

  const californiaDisclaimerWithoutERS = (
    <Typography variant="b3Regular" className="ca-ers-not-selected-disclaimer" sx={{ color: '#404040' }}>
      The total paid above reflects membership dues only. An additional ${ersFee} non-refundable service fee will be
      charged for Roadside Assistance for a vehicle disablement that occurred before you joined.
    </Typography>
  );

  const californiaDisclaimerWithERS = (
    <Typography className="ca-ers-selected-disclaimer" variant="b3Regular" sx={{ color: '#404040' }}>
      Please call 1-800-400-4222 and refer to the membership number above to have a service vehicle sent to assist you
      today.
    </Typography>
  );

  if (clubCode !== '004') {
    return nonCaliforniaDisclaimer;
  }

  return isERSSelected ? californiaDisclaimerWithERS : californiaDisclaimerWithoutERS;
};
